import Axios from "axios";
import { getApiUrl } from "./commanFunc";
import { logger } from "../shared/utils/helpers/logger";


export const apiInst = Axios.create({
    baseURL: getApiUrl(),
});

export function updateApiBaseUrl(newUrl, region) {
    // Update the Axios instance for future calls
    apiInst.defaults.baseURL = newUrl;
    // Persist using localStorage
    localStorage.setItem('api_base_url', newUrl);
    localStorage.setItem('api_region', region);
}

/**
 * Auth Header with Security Improvements
 * 
 * ✅ SECURITY FIXES:
 * 1. Null/undefined checking - prevents app crashes
 * 2. Try-catch error handling - graceful degradation
 * 3. Auto-redirect to login on missing token
 * 4. Safe JSON parsing
 * 5. Using sessionStorage instead of localStorage for better security
 * 
 * NOTE: sessionStorage is cleared on tab close, more secure than localStorage
 * Long-term fix: Move to httpOnly cookies (requires backend changes)
 */
export const authHeader = () => {
    try {
        const userStr = localStorage.getItem('user');
        const storeIdStr = localStorage.getItem('ds');
        
        if (!userStr) {
            logger.warn('🔒 No user data found. Redirecting to login...');
            window.location.href = '/login';
            return null;
        }
        
        const user = JSON.parse(userStr);
        console.log(user);
        
        // Validate JWT token exists
        if (!user?.jwt) {
            logger.warn('🔒 No authentication token found. Redirecting to login...');
            localStorage.removeItem('user');
            window.location.href = '/login';
            return null;
        }
        
        // Safely parse store ID (optional, may be null)
        let storeId = null;
        if (storeIdStr && storeIdStr !== 'null' && storeIdStr !== 'undefined') {
            try {
                storeId = JSON.parse(storeIdStr);
            } catch (e) {
                logger.warn('⚠️ Invalid store ID in storage');
            }
        }
        
        return {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.jwt}`,
                "Cache-Control": "no-cache",
            },
            storeid: storeId
        };
    } catch (error) {
        logger.error('🔒 Auth header error:', error.message);
        localStorage.removeItem('user');
        localStorage.removeItem('ds');
        window.location.href = '/login';
        return null;
    }
};

// export const crashLink = url + "/admin";
export const crashLink = () => `${getApiUrl()}/admin`;
export const supportEmail = "support@miirapos.com";

export const EqForm = async (data) => {
    try {
        const response = await apiInst.post('/enquieryForm', data);
        return response.data;
    } catch (error) {
        logger.error('Get User Info Error:', error);
    }
}

export const validationCheck = async (data, Logout) => {
    // Add null/undefined check
    if (!data) {
        logger.warn('⚠️ validationCheck called with undefined data');
        return null;
    }
    
    if (data.status === 401 || data.status === 406 || data.status === 404) {
        logger.log('🔒 Auth validation failed, logging out...');
        Logout(data.status);
    }
    else if (data.status === 500) {
        logger.log('🔥 Server error, logging out...');
        Logout(data.status);
    }
    return data?.data || null;
}

export const getUserInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/userInfo', data, authHeader());
        return response.data;
    } catch (error) {
        logger.error('Get User Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getPaymentStatus = (sessionId) => {
    return fetch(`${getApiUrl()}/api/stripe/payment-status`, {
        method: "POST", // Use POST method
        headers: {
            'Content-Type': 'application/json', // Specify the content type
        },
        // Send the session ID in the request body
        body: JSON.stringify(sessionId)
    })
        .then((res) => {
            // logger.log(res);
            if (!res.ok) {
                throw new Error("Failed to fetch payment status.");
            }
            return res.json();
        })
        .then((data) => {
            // logger.log(data);
            if (!data.status) {
                throw new Error("Payment status not received in response.");
            }
            return data;
        });
};

export const getINPaymentStatus = (sessionId) => {
    return fetch(`${getApiUrl()}/api/inpay/get-sub-details`, {
        method: "POST", // Use POST method
        headers: {
            'Content-Type': 'application/json', // Specify the content type
        },
        // Send the session ID in the request body
        body: JSON.stringify(sessionId)
    })
        .then((res) => {
            logger.log(res);
            if (!res.ok) {
                throw new Error("Failed to fetch payment status.");
            }
            return res.json();
        });
};



export const signupRestaurant = async (data) => {
    // logger.log(`Sending Data To SignUP ${data}`);
    try {
        const response = await apiInst.post('/signup', { data });
        // logger.log(response);
        return response.data;
    } catch (error) {
        // logger.error('Signup Error:', error);
        return await validationCheck(error.response);
    }
}

export const loginRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/login', data);
        return response.data;
    } catch (error) {
        logger.error('Login Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const forgotPasswordRequestRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/fgpreq', data);
        return response.data;
    } catch (error) {
        logger.error('Forgot Password Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const verifyOtpRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/verify-otp', data);
        return response.data;
    } catch (error) {
        logger.error('Verify OTP Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const resetPasswordRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/reset-password', data);
        return response.data;
    } catch (error) {
        logger.error('Reset Password Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const checkUserEmail = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/checkEmail', data, authHeader());
        return response.data;
    } catch (error) {
        logger.error('Check User Email Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const addStore = async (data, Logout) => {
    try {
        const response = await apiInst.post('/addStore', data, authHeader());
        return response.data;
    } catch (error) {
        logger.error('Add Store Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getlistCatgory = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/listCatgory', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get List Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
// Handle  Dashboard API....
export const getDashboardData = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/dashboardData', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get List Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// ///**********All Menu Api Handling*********/
// Handle Menu page apis...
export const addMenu = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/addMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const addMenuBulk = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/addMenuBulk', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Bulk Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


// Under Comman Api Hadler.....
export const getlistMenu = async (data, Logout) => {
    try {
        const response = await apiInst.post('/listMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get List Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const editItemCall = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/editItem', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const editCatgCall = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/editCatgory', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const deleteItem = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/removeItem', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const deleteCategory = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/removeCatgory', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

///*****End of Menu API Handling.... */

/// **** Following api to handle Inventory Page... */
export const getMenuInventory = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/getMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};

export const getInventoryLogsAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/productRecords', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};

export const linkMenuItemAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/linkMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};

export const recordLogAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/recordProductBlk', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};
/// ***** End of Inventory Page API Handling... */

/// handle Online..
export const getOnlineInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/storeContent', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const updateOnlineInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/updateStoreContent', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}





// export const sendOrder = async (data, Logout) => {
//     try {
//         const response = await apiInst.post('/admin/sendOrder', data, authHeader());
//         return await validationCheck(response, Logout);
//     } catch (error) {
//         logger.error('Send Order Error:', error);
//         return await validationCheck(error.response, Logout);
//     }
// }

// export const checkOut = async (data, Logout) => {
//     try {
//         const response = await apiInst.post('/admin/orderCheckout', data, authHeader());
//         return await validationCheck(response, Logout);
//     } catch (error) {
//         logger.error('Check Out Error:', error);
//         return await validationCheck(error.response, Logout);
//     }
// }

// export const itemRemove = async (data, Logout) => {
//     try {
//         const response = await apiInst.post('/admin/removeItem', data, authHeader());
//         return await validationCheck(response, Logout);
//     } catch (error) {
//         logger.error('Item Remove Error:', error);
//         return await validationCheck(error.response, Logout);
//     }
// }

export const ListStore = async (Logout) => {
    try {
        const response = await apiInst.post('/listStore', {}, authHeader());
        return response.data;
    } catch (error) {
        logger.error('List Store Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const addUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/addUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const editUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/editUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Edit User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const listUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/listUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('List User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const getPaymentSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getPaySetting', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('List User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const setPaymentSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setPaySetting', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('List User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const deleteUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/removeUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Delete User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
/// ***** Setting Payment Section *****///

export const AddPayMeth = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/addPaymentMode', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const UpdatePayMeth = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/updatePaymentMode', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const DeletePayMeth = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/removePaymentMode', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const saveLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/addLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Save Layout Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const deleteLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/removeLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Save Layout Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/layout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Layout Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// /** This is not need to change... as going direct to device api */
export const generateDeviceToken = async (data, Logout) => {
    try {
        const response = await apiInst.post('/device/generateToken', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Generate Device Token Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const getCurrentOrder = async (data, Logout) => {
    try {
        console.log('Data for current order:', data); // Debugging line
        const response = await apiInst.post('/admin/dailyOrder', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get currentOrder Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getBulkOrderData = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/dailyOrderBulk', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Bulk Report Data Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
//****API handling for Report page */
export const getUserTimeLogAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/reports/user-timelogs', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


///****End of Report Page */



//****API handling for general section in setting page */
export const getStoreConfig = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/getStoreConfig', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getStoreInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/storeInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const editStoreInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/storeInfoEdit', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
// /*Handling device Apis... */
export const getdeviceInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/devices', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Device Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const removeDevice = async (data, Logout) => {
    /// This will Handle all device Removal form Terminal, Printers, KDS, CLS
    try {
        const response = await apiInst.post('/admin/setting/removeDevice', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Remove Device Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const staChangeDevice = async (data, Logout) => {
    /// This will Handle all device Removal form Terminal, Printers, KDS, CLS
    try {
        const response = await apiInst.post('/admin/setting/update-device-status', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Remove Device Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

/*** API to handle api devices ***/
export const addPrinter = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/addPrinter', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Remove Device Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

/***API to handle Payment option in setting section */

export const getDevicePayment = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getPaymentInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getSubDetails = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getSubInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

/**This is List all store user Punch's */

export const getPunchDetails = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/userTimeLogs', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get currentOrder Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Api to handle advance Setting....
export const getAdvanceInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getAdvInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const setAdvanceInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setAdvsetting', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Api to handle Notification Settings
export const getNotificationSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getNotificSett', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const setNotificationSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setNotificSett', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const getPrintLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/priLay/getPrinterLayouts', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const savePrintLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/priLay/savePrinterLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const deletePrintLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/priLay/removePrinterLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const getTimeLogs = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getTimeLog', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const punchTime = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setTimeLog', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const deleteTimeLog = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/deleteTimeLog', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
/// this is API to handle Booking...
export const getBookingData = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/getBookingData', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const saveBooking = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/createBooking', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const updateBookingStatus = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/updateStatus', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const saveBookingSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/saveReservationConfig', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// New Unified Booking Settings API
export const getUnifiedBookingSettings = async (storeID, Logout) => {
    try {
        const response = await apiInst.get(`/admin/book/settings?storeID=${storeID}`, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Unified Booking Settings Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const saveUnifiedBookingSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/settings', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Save Unified Booking Settings Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const toggleBookingSetting = async (data, Logout) => {
    try {
        const response = await apiInst.patch('/admin/book/settings/toggle', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Toggle Booking Setting Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const generateTimeSlots = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/settings/generate-slots', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Generate Time Slots Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// =========================================================================
// Service Provider Management APIs
// =========================================================================

// Get all providers for a store
export const getServiceProviders = async (storeID, Logout) => {
    try {
        const response = await apiInst.get(`/admin/book/providers?storeID=${storeID}`, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Service Providers Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Create new provider
export const createServiceProvider = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/providers', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Create Service Provider Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Update provider
export const updateServiceProvider = async (providerID, data, Logout) => {
    try {
        const response = await apiInst.put(`/admin/book/providers/${providerID}`, data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Update Service Provider Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Delete provider
export const deleteServiceProvider = async (providerID, Logout) => {
    try {
        const response = await apiInst.delete(`/admin/book/providers/${providerID}`, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Delete Service Provider Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Toggle provider active status
export const toggleProviderStatus = async (providerID, isActive, Logout) => {
    try {
        const response = await apiInst.patch(`/admin/book/providers/${providerID}/toggle`, { isActive }, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Toggle Provider Status Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// =========================================================================
// Booking/Appointment Management APIs
// =========================================================================

// Get available time slots for booking
export const getAvailableSlots = async (params, Logout) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const response = await apiInst.get(`/admin/book/available-slots?${queryString}`, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Available Slots Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Create new booking/appointment
export const createBooking = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/createBooking', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Create Booking Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Get service list for booking
export const getServiceList = async (params, Logout) => {
    try {
        const { storeID, providerID, onlineOnly } = params;
        let queryString = `storeID=${storeID}`;
        if (providerID) queryString += `&providerID=${providerID}`;
        if (onlineOnly) queryString += `&onlineOnly=${onlineOnly}`;
        
        const response = await apiInst.get(`/admin/menu/getServicelist?${queryString}`, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Service List Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Assign provider to existing booking (walk-in scenario)
export const assignProviderToBooking = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/book/assign-provider', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Assign Provider Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


// Side-Car (Modifier) Management
export const getSideCars = async (data, Logout) => {
    try {
        // GET request expects params in query
        const response = await apiInst.post(`admin/setting/sideCar/getSideCars`, data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        return await validationCheck(error.response, Logout);
    }
};

export const saveSideCar = async (data, Logout) => {
    try {
        // POST request for Create/Update
        const response = await apiInst.post('admin/setting/sideCar/saveSideCar', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        return await validationCheck(error.response, Logout);
    }
};

export const removeSideCar = async (data, Logout) => {
    try {
        // DELETE request using query params as defined in Node.js router
        const response = await apiInst.post(`admin/setting/sideCar/removeSideCar`, data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        return await validationCheck(error.response, Logout);
    }
};


export const saveConfig = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/tdpint/saveDeliveryConfig', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Save Config Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const syncMenu = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/tdpint/syncMenuMapping', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Sync Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getDeliverySettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/tdpint/getDeliverySettings', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Delivery Settings Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const disconnectPlatform = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/tdpint/disconnectPlatform', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Disconnect Platform Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const removeConnInteg = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/tdpint/removeConnection', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Remove Connection Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const saveFranchise = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/franchise/addFranchise', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Save Franchise Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


// const fetchSettings = async (storeID, token) => {
//   const response = await fetch(`${API_BASE}/getDeliverySettings?storeID=${storeID}`, {
//     headers: { 'Authorization': `Bearer ${token}` }
//   });
//   return response.json();
// };
///
// const syncMenu = async (storeID, platform, mappings, token) => {
//   const response = await fetch(`${API_BASE}/syncMenuMapping`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
//     body: JSON.stringify({ storeID, platform, mappings })
//   });
//   return response.json();
// };



export const getSiteBasicInfo = async (data, Logout) => {
    try {
        // Send storeID in the post body matching your standard architecture
        const response = await apiInst.post('/online/getSiteBasic', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Get Site Basic Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
};

export const updateSiteBasicInfo = async (data, Logout) => {
    try {
        // Post the updated formData along with the storeID
        const response = await apiInst.post('/online/updateSiteBasic', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        logger.error('Update Site Basic Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
};